

import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from 'vue'
import FastClick from 'fastclick'

import App from './App'
import router from './router/index'
import store from './store/index'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'




import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale'

import "@/assets/iconfont/iconfont.css"
import "@/assets/scss/list.scss";

import i18n from './lang'
import commonfunc from './js/common'

import './pccomponents/index'


import * as axios from "@/store/http";
import formValidate from "@/js/formValidate";
import cal from '@/js/calculation';
import Router from 'vue-router'
import $isMobile from './utils/isMobile'
Vue.use($isMobile)


import msgDailog from './pcpage/hr/recruitment/portal/component/msgDailog/index';
Vue.use(msgDailog);


Vue.prototype.axios = axios
Vue.prototype.$formValidate = formValidate
Vue.prototype.cal = cal
promise.polyfill();
Vue.use(commonfunc)

Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

Vue.use(ElementUI)




FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.config.devtools = true
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
var sysname = process.env.SYS_NAME;
Vue.filter('filterDate', function (value) {
if(!value || sysname != 'HR') return value;
let day = value.split("-")[0];
let month = value.split("-")[1];
let year = value.split("-")[2];
let f_month = "";
switch(month) {
case '01' : f_month = "Jan"; break;
case '02' : f_month = "Feb"; break;
case '03' : f_month = "Mar"; break;
case '04' : f_month = "Apr"; break;
case '05' : f_month = "May"; break;
case '06' : f_month = "Jun"; break;
case '07' : f_month = "Jul"; break;
case '08' : f_month = "Aug"; break;
case '09' : f_month = "Sept"; break;
case '10' : f_month = "Oct"; break;
case '11' : f_month = "Nov"; break;
case '12' : f_month = "Dec"; break;
default: f_month = "MM"; break;

}
return day+"-"+f_month+"-"+year;
});

Vue.filter('monthFilterDate', function (value) {
if(!value || sysname != 'HR') return value;
let month = value.split("-")[0];
let year = value.split("-")[1];
let f_month = "";
switch(month) {
case '01' : f_month = "Jan"; break;
case '02' : f_month = "Feb"; break;
case '03' : f_month = "Mar"; break;
case '04' : f_month = "Apr"; break;
case '05' : f_month = "May"; break;
case '06' : f_month = "Jun"; break;
case '07' : f_month = "Jul"; break;
case '08' : f_month = "Aug"; break;
case '09' : f_month = "Sept"; break;
case '10' : f_month = "Oct"; break;
case '11' : f_month = "Nov"; break;
case '12' : f_month = "Dec"; break;
default: f_month = "MM"; break;

}
return f_month+"-"+year;
});
locale.i18n((key, value) => i18n.t(key, value));
router.beforeEach((to,from,next)=>{
if(to.meta.title){
if(sysname === 'HR'){
document.title =to.meta.title;
}
}
next()
}
);
/* eslint-disable no-new */
new Vue({
router,
store,
i18n,
render: h => h(App),
}).$mount('#app-box')




// WEBPACK FOOTER //
// ./src/main.js